import {UntypedFormControl} from '@angular/forms';

// const fullPatternOrcidRegex = new RegExp(/^(?:https:\/\/orcid.org\/)?(\d{4}\-\d{4}\-\d{4}\-\d{3}(?:\d|X))$/);
const simpleOrcidRegex = new RegExp(/^(\d{4}\-\d{4}\-\d{4}\-\d{3}(?:\d|X))$/);
export function orcidFormat(control: UntypedFormControl) {
    const orcid = control.value as string;
    return orcid && !simpleOrcidRegex.test(orcid) ?
        { orcidFormat: 'research.apc.form.researcher.orcid.error' } :
        null;
}
